'use client';

import { UiKitListCharacteristic } from '@/fo/ui/kit/list/characteristic';
import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './UiProductInfoCharacteristics.styles';

export interface UiProductInfoCharacteristicsProps {
  product: MappedProduct;
}

export function UiProductInfoCharacteristics({
  product
}: UiProductInfoCharacteristicsProps) {
  const slots = styles();

  return (
    <UiKitListCharacteristic
      className={slots.base()}
      items={product.characteristics.map(({ label, value }) => ({
        label: <p className={slots.label()}>{label}</p>,
        value: <p className={slots.value()}>{value}</p>
      }))}
    />
  );
}
